import CollapsibleView from './collapsible-view'

export default CollapsibleView
